import { render } from "./trkShow.vue?vue&type=template&id=60314496"
import script from "./trkShow.vue?vue&type=script&lang=js"
export * from "./trkShow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__